import React from "react";
import { Receipt } from "../services/receipt-service";

interface ReceiptDetailProps {
  open: boolean;
  onClose: () => void;
  data?: Receipt | null;
}

export const ReceiptDetail: React.FC<ReceiptDetailProps> = ({ open, onClose, data }) => {
  if (!open || !data) return null;

  const mapType = (t?: number) =>
    t === 1 ? "Phiếu Thu" : t === 2 ? "Phiếu Chi" : "—";
  const mapStatus = (s?: number) =>
    ({ 1: "Chờ duyệt", 2: "Đã duyệt", 3: "Từ chối", 4: "Đã huỷ" }[
      Number(s || 0)
    ] || "—");

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 animate-fadeIn">
      <div className="bg-white rounded-2xl w-[600px] shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-green-500 text-white px-6 py-3 flex justify-between items-center">
          <h3 className="text-lg font-semibold">Chi tiết Phiếu Thu/Chi</h3>
          <button
            onClick={onClose}
            className="text-white text-2xl leading-none hover:opacity-80"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4 text-gray-800">
          {/* Số chứng từ */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">
              Số chứng từ
            </p>
            <p className="text-base text-black">
              {data.document_number || `RC-${data.id}`}
            </p>
          </div>

          {/* Loại phiếu */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">
              Loại phiếu
            </p>
            <p
              className={`text-base font-medium ${
                data.type === 1 ? "text-green-700" : "text-red-700"
              }`}
            >
              {mapType(data.type)}
            </p>
          </div>

          {/* Danh mục */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">
              Danh mục thu chi
            </p>
            <p className="text-base text-black">{data.category_name || `#${data.receipt_category_id}` || "—"}</p>
          </div>

          {/* Số tiền */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Số tiền</p>
            <p
              className={`text-2xl font-bold ${
                data.type === 1 ? "text-green-700" : "text-red-700"
              }`}
            >
              {Number(data.amount ?? 0).toLocaleString()} ₫
            </p>
          </div>

          {/* Ngày tạo */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-semibold text-gray-600 mb-1">
                Ngày tạo
              </p>
              <p className="text-base text-black">{data.created_at || "—"}</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-600 mb-1">
                Ngày hạch toán
              </p>
              <p className="text-base text-black">
                {data.transaction_date || "—"}
              </p>
            </div>
          </div>

          {/* Người tạo */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-semibold text-gray-600 mb-1">
                Người tạo
              </p>
              <p className="text-base text-black">
                {data.entry_type === 1 ? (
                  <span className="text-green-600 font-medium">Tự động</span>
                ) : (
                  data.user_id || "—"
                )}
              </p>
            </div>
            {/* Trạng thái */}
            <div>
              <p className="text-sm font-semibold text-gray-600 mb-1">
                Trạng thái
              </p>
              <p
                className={`text-base font-medium ${
                  data.status === 2
                    ? "text-green-700"
                    : data.status === 3
                    ? "text-red-700"
                    : data.status === 4
                    ? "text-gray-600"
                    : "text-yellow-600"
                }`}
              >
                {mapStatus(data.status)}
              </p>
            </div>
          </div>


          {/* Ghi chú */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Ghi chú</p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-base text-gray-800 min-h-[80px] whitespace-pre-line break-words max-h-[180px] overflow-auto">
              {data.note || "Không có ghi chú"}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition font-medium"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};
